module.exports = __webpack_public_path__ + "static/media/randomDraw.svg";